import React from 'react';

import { RouteMap } from '../../components/Route/RouteMap';
import {
  routeOrdersToStages,
  stagesToRouteOrders,
  getNewStageIndex,
  RouteElementType,
} from '../../utils/utils';

const MAX_ROUTE_ORDERS = 25;

export const RouteMapContainer = ({
  distance,
  orders,
  routeOrders,
  formRouteOrders,
  onUpdateOrder,
  onEndPointViaChange,
  onUpdateRouteOrder,
  onUpdateRouteOrders,
  endPoint,
  startPoint,
  routeCar,
  confirmedVolumeM3,
  totalVolumeM3,
  confirmedIncomePrice,
  totalIncomePrice,
  isNotPricedPackages,
  orderConfirmedIncomePrice,
  orderTotalIncomePrice,
  exchangeConfirmedIncomePrice,
  exchangeTotalIncomePrice,
  onRouteCalculated,
  disableButtons,
  departureTime,
  routeId,
  handleBeforeApiCall,
  hasReturnPicking = false,
}) => {
  const handleAddDriverBreakTime = (index, durationInMin) => {
    const stages = routeOrdersToStages(routeOrders);
    const stage = Object.keys(stages).reverse()[0];

    stages[stage] = (stages[stage]).concat({
      ordering: 0,
      stage: '1',
      durationInMin,
      unloadingTime: 0,
      uuid: crypto.randomUUID(),
      type: RouteElementType.DRIVER_BREAK_TIME,
      order: {
        trackingId: `Driver-break-${index}`,
        incomePrice: {
          price: 0,
          notPricedPackages: [],
        },
        sender: {},
      }
    });

    onUpdateRouteOrders(stagesToRouteOrders(stages));
  };

  const handleSelectOrder = (order) => {
    const stages = routeOrdersToStages(routeOrders);
    const stage =
      Object.keys(stages)
        .reverse()
        .find((key) => stages[key].length < MAX_ROUTE_ORDERS) || getNewStageIndex(stages);

    stages[stage] = (stages[stage] || []).concat({
      order,
      orderId: order.id,
      uuid: crypto.randomUUID(),
      ordering: 0,
      stage: '1',
      via: [],
      type: RouteElementType.ROUTE_ORDER,
    });

    onUpdateRouteOrders(stagesToRouteOrders(stages));
    onUpdateOrder(order.id, { selected: true });
  };

  const handleRemoveDriverBreak = (routeElement) => {
    let updatedRouteOrders = [...routeOrders];

    updatedRouteOrders = updatedRouteOrders.filter((element) =>
      element.type === RouteElementType.ROUTE_ORDER || element.uuid !== routeElement.uuid
    );

    onUpdateRouteOrders(updatedRouteOrders);
  };

  const handleUnselectOrder = (order) => {
    onUpdateOrder(order.id, { ...order, selected: false });
    const indexToRemove = routeOrders
      .filter((element) => element.type === RouteElementType.ROUTE_ORDER)
      .findIndex(({ order: { id } }) => id === order.id);

    let updatedRouteOrders = [...routeOrders];

    if (indexToRemove > 0) {
      const dailyBreakMinutes = routeOrders[indexToRemove]?.dailyBreakMinutes ?? 0;
      updatedRouteOrders[indexToRemove - 1] = {
        ...updatedRouteOrders[indexToRemove - 1],
        dailyBreakMinutes,
      };
    }

    updatedRouteOrders = updatedRouteOrders.filter((element) =>
      element.type === RouteElementType.DRIVER_BREAK_TIME || element.order.id !== order.id
    );

    onUpdateRouteOrders(updatedRouteOrders);
  };

  return (
    <>
      <RouteMap
        endPoint={endPoint}
        startPoint={startPoint}
        departureTime={departureTime}
        routeCar={routeCar}
        orders={orders}
        routeOrders={routeOrders}
        formRouteOrders={formRouteOrders}
        disableButtons={disableButtons}
        confirmedVolumeM3={confirmedVolumeM3}
        totalVolumeM3={totalVolumeM3}
        confirmedIncomePrice={confirmedIncomePrice}
        totalIncomePrice={totalIncomePrice}
        isNotPricedPackages={isNotPricedPackages}
        orderConfirmedIncomePrice={orderConfirmedIncomePrice}
        orderTotalIncomePrice={orderTotalIncomePrice}
        exchangeConfirmedIncomePrice={exchangeConfirmedIncomePrice}
        exchangeTotalIncomePrice={exchangeTotalIncomePrice}
        distance={distance}
        maxRouteOrders={MAX_ROUTE_ORDERS}
        onSelectOrder={handleSelectOrder}
        onUnselectOrder={handleUnselectOrder}
        onAddDriverBreakTime={handleAddDriverBreakTime}
        onRouteCalculated={onRouteCalculated}
        onEndPointViaChange={onEndPointViaChange}
        onUpdateRouteOrder={onUpdateRouteOrder}
        onUpdateRouteOrders={onUpdateRouteOrders}
        handleBeforeApiCall={handleBeforeApiCall}
        onRemoveDriverBreak={handleRemoveDriverBreak}
        routeId={routeId}
        hasReturnPicking={hasReturnPicking}
      />
    </>
  );
};
